import axios from 'axios'
import LocalStorageHelper from '../LocalStorageHelper/LocalStorageHelper'
import {parseCookies} from 'nookies'

export const nextRestClient = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
})

export const nextRestClientGUS = axios.create({
    baseURL: 'https://wyszukiwarkaregontest.stat.gov.pl/wsBIR/UslugaBIRzewnPubl.svc',
})

export const clientURL = {
    pl: process.env.NEXT_PUBLIC_CLIENT_URL_PL,
    en: process.env.NEXT_PUBLIC_CLIENT_URL_EN,
    de: process.env.NEXT_PUBLIC_CLIENT_URL_DE,
    fr: process.env.NEXT_PUBLIC_CLIENT_URL_FR,
}

export const magentoRestClient = axios.create({
    baseURL: process.env.NEXT_PUBLIC_MAGENTO_API_URL_REST,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
})

magentoRestClient.interceptors.request.use(
    (config: { headers: any, method: any, params: any, data: any, url: any }) => {
        const cookies: Record<string, string> = parseCookies()
        const formattedCookies = Object.entries(cookies)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('; ')
        const locale = LocalStorageHelper.get('locale')
        config.headers['Access-Control-Allow-Origin'] = clientURL[locale]
        config.headers['cookies'] = formattedCookies
        config.headers['store'] = locale
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

magentoRestClient.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error)
    }
)
